import { UIActionType, UIAction } from '../../actions/uiActions';

const selectedStatisticsProcessIdReducer = (state = 'all', action: UIAction) => {
  if (action.type === UIActionType.SET_SELECTED_STATISTICS_PROCESS_ID) return action.id;
  return state;
};

export default selectedStatisticsProcessIdReducer;
